import React from 'react';
import moment from 'moment';
import IntervalRenderer from 'flow/components/custom-components/interval-renderer';
import { getDaysHoursMinutesSeconds } from 'flow/utils/date-time-utils';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    joinTime: string;
}
const TimeSinceJoinedItem = ({ joinTime }: Props) => {
    const { i18next } = useAppContext();

    return (
        <IntervalRenderer interval={1000}>
            {() => {
                const now = moment();
                const timeDuration = moment.duration(now.diff(joinTime));
                const timeDurationMilliseconds = timeDuration.asMilliseconds();
                const timeSinceJoined = getDaysHoursMinutesSeconds(
                    timeDurationMilliseconds,
                    i18next,
                );

                return <React.Fragment>{timeSinceJoined}</React.Fragment>;
            }}
        </IntervalRenderer>
    );
};

export default React.memo(TimeSinceJoinedItem);
